/**
 * @description 埋点系统入口 - 集中配置管理方案
 * @author zcq
 * @date 2025-04-18
 */

import { BurialPointManager } from './burial-manager';
import { ETrackingType, ERegion, EBurialFramework, EEnvironment, EPlatform } from './types';
import { ConfigurationManager } from './configuration-manager';

// 获取埋点管理器单例
const burialPointManager = BurialPointManager.getInstance();

// write by cursor
/**
 * 埋点系统API - 用于应用程序调用
 */
export const burialPoint = {
  // 初始化埋点系统
  init: (platform?: string, endpoint?: string, env?: string): Promise<void> => {
    console.log('init', platform);
    if (platform) {
      burialPointManager.setPlatform(platform);
    }
    return burialPointManager.initialize(endpoint, env);
  },

  // 发送事件
  sendEvent: (eventType: string, eventName: string, params?: Record<string, any>): void => {
    burialPointManager.sendEvent(eventType, eventName, params);
  },

  // 开始性能追踪
  startTrace: (traceName: string): void => {
    burialPointManager.startTrace(traceName);
  },

  // 结束性能追踪
  stopTrace: (traceName: string): void => {
    burialPointManager.stopTrace(traceName);
  },
};

// 导出初始化函数作为便捷API
export const initializeBurialPoint = burialPoint.init;

// 允许通过API修改配置
export { ConfigurationManager, EPlatform };

// 导出枚举类型供应用使用
export type {
  ETrackingType,
  ERegion,
  EBurialFramework,
  EEnvironment
};
